// extracted by mini-css-extract-plugin
export default {"medium":"styles_medium__Ha9a5","large":"styles_large__ExfMb"};